'use strict';

var messageDiscriptors = require('./messageDiscriptors');
var util = require('./property-util');


module.exports = {
    getMessageFields: function (translateService) {
        var fields = {};

        var gpsData = {
            'properties': [
                messageDiscriptors.createDescriptor('speed', 'kmperh-axis', 'Speed'),
                messageDiscriptors.createDescriptor('heading', 'small-number-scale', 'Heading'),
                messageDiscriptors.createDescriptor('valid', 'gps-valid-scale', 'Valid', true)
            ],
            'isArray': false,
            'name': 'GPS Data',
            'rate': 1,
            'useRate': false
        };

        var capacityTestData = {
            'isArray': true,
            'isSubDiscriminator': true,
            'name': 'Capacity test statistics',
            'rate': 1,
            'discriminatorField': 'boxId',
            'subDiscriminatorField': 'link',
            'discriminatorNames': [],
            'discriminatorLabel': 'Links CCU',
            'subDiscriminatorLabel': 'box',
            'properties': [
                messageDiscriptors.createDescriptor('rateMbps', 'kbitspers', 'Tested download rate')
            ],
            'useRate': false
        };

        var virtualUser = {
            'properties': [
                messageDiscriptors.createDescriptor('dnsTime', 'seconds-scale', 'Dns time', null, true),
                messageDiscriptors.createDescriptor('connectTime', 'seconds-scale', 'Connect time', null, true),
                messageDiscriptors.createDescriptor('applicationConnectTime', 'seconds-scale', 'Appconnect time', null, true),
                messageDiscriptors.createDescriptor('preTransferTime', 'seconds-scale', 'Pretransfer time', null, true),
                messageDiscriptors.createDescriptor('redirectTime', 'seconds-scale', 'Redirect time', null, true),
                messageDiscriptors.createDescriptor('startTransferTime', 'seconds-scale', 'Start transfer time'),
                messageDiscriptors.createDescriptor('totalTime', 'seconds-scale', 'Total time', null, true),
                messageDiscriptors.createDescriptor('httpCode', 'small-number-scale', 'HTTP code'),
                messageDiscriptors.createDescriptor('size', 'small-number-scale', 'Size'),
                messageDiscriptors.createDescriptor('connections', 'small-number-scale', 'Connections'),
                messageDiscriptors.createDescriptor('curlResponseCode', 'small-number-scale', 'Response code')
            ],
            'isArray': true,
            'name': 'Virtual user',
            'rate': 1,
            'useRate': false,
            'discriminatorField': 'boxId',
            'discriminatorNames': [],
            'discriminatorLabel': 'CCU',
            'isSubDiscriminator': false
        };

        var trainUsers = {
            'isArray': true,
            'name': 'Device count',
            'rate': 1,
            'discriminatorField': 'boxId',
            'discriminatorNames': [],
            'discriminatorLabel': 'CCU',
            'isSubDiscriminator': false,
            'properties': [
                messageDiscriptors.createDescriptor('logins', 'small-number-scale', 'Devices connected to internet'),
                messageDiscriptors.createDescriptor('sessions', 'small-number-scale', 'Devices connected to Wi-Fi'),
                messageDiscriptors.createDescriptor('staffCount', 'small-number-scale', 'Devices connected to staff network')
            ],
            'useRate': false
        };


        var allTrainUsers = {
            'isArray': false,
            'name': 'Combined device count',
            'rate': 1,
            'properties': [
                messageDiscriptors.createDescriptor('logins', 'small-number-scale', 'Devices connected to internet'),
                messageDiscriptors.createDescriptor('sessions', 'small-number-scale', 'Devices connected to Wi-Fi'),
                messageDiscriptors.createDescriptor('staffCount', 'small-number-scale', 'Devices connected to staff network')
            ],
            'useRate': false
        };

        var allPortalConsumption = {
            'isArray': false,
            'name': 'Combined portal consumption',
            'rate': 1,
            'properties': [
                messageDiscriptors.createDescriptor('dbValue', 'big-throughput-bytes', 'Bytes consumed')
            ],
            'useRate': false
        };

        var mar3LinkStatistic = {
            'isArray': true,
            'isSubDiscriminator': true,
            'name': 'Link statistics',
            'rate': 1,
            'discriminatorField': 'boxId',
            'subDiscriminatorField': 'link',
            // 'discriminatorNames' will be replaced by the discriptor service
            // it will be a 2 dimensional array [ box id , [ MODEM 1, MODEM 2,MODEM 3] ]
            'discriminatorNames': [],
            'discriminatorLabel': 'Links CCU',
            'subDiscriminatorLabel': 'box',
            'aggregateVlinks': true,
            'properties': [
                messageDiscriptors.createDescriptor('vpnUp', 'boolean-up-down', 'Vpn up', true),
                messageDiscriptors.createDescriptor('bitsSent', 'big-throughput-bitspers', 'Upload rate'),
                messageDiscriptors.createDescriptor('bitsReceived', 'big-throughput-bitspers', 'Download rate'),
                messageDiscriptors.createDescriptor('signalQuality', 'zero-to-hundred', 'Signal quality'),
                messageDiscriptors.createDescriptor('lac', 'lac', 'Location area code', true),
                messageDiscriptors.createDescriptor('cellId', 'cell-id', 'Cell ID', true),
                messageDiscriptors.createDescriptor('packetLoss', 'zero-to-hundred', 'Packet loss'),
                messageDiscriptors.createDescriptor('averageLatency', 'avg-mar3-latency', 'Average latency'),
                messageDiscriptors.createDescriptor('technology', 'cell-technology-axis', 'Radio access technology', true),
                messageDiscriptors.createDescriptor('operatorCode', 'operator-code-axis', 'Operator code', true),
                messageDiscriptors.createDescriptor('nType', 'network-type-axis', 'Network type', true),
                messageDiscriptors.createDescriptor('mState', 'modem-state-axis', 'Modem state', true),
                messageDiscriptors.createDescriptor('kbpsPerSession', 'kbitspers', 'Kbps per session')
            ],
            'useRate': false
        };

        var mar3LinkCombined = {
            'properties': [
                messageDiscriptors.createDescriptor('totalReceived', 'big-throughput-bitspers', 'Total download rate'),
                messageDiscriptors.createDescriptor('totalSent', 'big-throughput-bitspers', 'Total upload rate'),
                messageDiscriptors.createDescriptor('avgPacketLoss', 'zero-to-hundred', 'Average packet loss'),
                messageDiscriptors.createDescriptor('avgSignalQuality', 'zero-to-hundred', 'Average signal quality'),
                messageDiscriptors.createDescriptor('avgLatency', 'avg-mar3-latency', 'Average latency')
            ],
            'isArray': false,
            'name': 'Combined link statistics',
            'rate': 1,
            'useRate': false
        };

        var mar3CombinedLinkSession = {
            'properties': [
                messageDiscriptors.createDescriptor('totalSessions', 'k-number-scale', 'Total sessions'),
                messageDiscriptors.createDescriptor('tcpSessions', 'k-number-scale', 'TCP sessions'),
                messageDiscriptors.createDescriptor('udpSessions', 'k-number-scale', 'UDP sessions'),
                messageDiscriptors.createDescriptor('icmpSessions', 'k-number-scale', 'ICMP sessions'),
                messageDiscriptors.createDescriptor('links', 'small-number-scale', 'Links')
            ],
            'isArray': false,
            'name': 'Combined link sessions',
            'rate': 1,
            'useRate': false
        };

        var mar3LteStatistic = {
            'isArray': true,
            'isSubDiscriminator': true,
            'name': 'LTE statistics',
            'rate': 1,
            'discriminatorField': 'boxId',
            'subDiscriminatorField': 'link',
            'discriminatorNames': [],
            'discriminatorLabel': 'Links CCU',
            'subDiscriminatorLabel': 'box',

            'properties': [
                messageDiscriptors.createDescriptor('lteBand', 'band-axis', 'LTE band', true),
                messageDiscriptors.createDescriptor('lteBw', 'zero-to-50Mhz', 'LTE bandwidth'),
                messageDiscriptors.createDescriptor('lteRxChannel', 'channel-axis', 'LTE Rx channel'),
                messageDiscriptors.createDescriptor('lteTxChannel', 'channel-axis', 'LTE Tx channel'),
                messageDiscriptors.createDescriptor('emm', 'emm-state-axis', 'EMM state', true),
                messageDiscriptors.createDescriptor('service', 'service-state-axis', 'Service state', true),
                messageDiscriptors.createDescriptor('rrc', 'rrc-state-axis', 'RRC state', true),
                messageDiscriptors.createDescriptor('imsReg', 'ims-reg-state-axis', 'IMS reg state', true),
                messageDiscriptors.createDescriptor('rssi', 'negative-dbm', 'RSSI'),
                messageDiscriptors.createDescriptor('txPower', 'negative-dbm', 'Tx power'),
                messageDiscriptors.createDescriptor('rsrp', 'negative-dbm', 'RSRP'),
                messageDiscriptors.createDescriptor('rsrq', 'db-axis', 'RSRQ'),
                messageDiscriptors.createDescriptor('sinr', 'db-axis', 'SINR'),
                messageDiscriptors.createDescriptor('caState', 'ca-state-axis', 'CA state', true),
                messageDiscriptors.createDescriptor('secLteBand', 'band-axis', 'Second LTE band'),
                messageDiscriptors.createDescriptor('secLteBw', 'zero-to-50Mhz', 'Second LTE bandwidth'),
                messageDiscriptors.createDescriptor('secLteChannel', 'channel-axis', 'Second LTE channel'),
                messageDiscriptors.createDescriptor('pccRxmRssi', 'negative-dbm', 'PCC Rxm RSSI'),
                messageDiscriptors.createDescriptor('pccRxmRsrp', 'negative-dbm', 'PCC Rxm RSRP'),
                messageDiscriptors.createDescriptor('pccRxdRssi', 'negative-dbm', 'PCC Rxd RSSI'),
                messageDiscriptors.createDescriptor('pccRxdRsrp', 'negative-dbm', 'PCC Rxd RSRP'),
                messageDiscriptors.createDescriptor('sccRxmRssi', 'negative-dbm', 'SCC Rxm RSSI'),
                messageDiscriptors.createDescriptor('sccRxmRsrp', 'negative-dbm', 'SCC Rxm RSRP'),
                messageDiscriptors.createDescriptor('sccRxdRssi', 'negative-dbm', 'SCC Rxd RSSI'),
                messageDiscriptors.createDescriptor('sccRxdRsrp', 'negative-dbm', 'SCC Rxd RSRP')
            ],
            'useRate': false
        };

        var mar3GsmStatistic = {
            'isArray': true,
            'isSubDiscriminator': true,
            'name': 'GSM statistics',
            'rate': 1,
            'discriminatorField': 'boxId',
            'subDiscriminatorField': 'link',
            'discriminatorNames': [],
            'discriminatorLabel': 'Links CCU',
            'subDiscriminatorLabel': 'box',

            'properties': [
                messageDiscriptors.createDescriptor('gsmBand', 'band-axis', 'GSM band', true),
                messageDiscriptors.createDescriptor('gsmChannel', 'channel-axis', 'GSM channel'),
                messageDiscriptors.createDescriptor('gmm', 'gmm-state-axis', 'GMM state', true),
                messageDiscriptors.createDescriptor('plmn1', 'plmn-state-axis', 'PLMN state 1', true),
                messageDiscriptors.createDescriptor('mm', 'mm-state-axis', 'MM state', true),
                messageDiscriptors.createDescriptor('plmn2', 'plmn-state-axis', 'PLMN state 2', true),
                messageDiscriptors.createDescriptor('servingCell', 'tinyint-nounit-axis', 'Serving cell', true),
                messageDiscriptors.createDescriptor('servingCellBandFormatted', 'serving-cell-band-axis', 'Serving cell band', true),
                messageDiscriptors.createDescriptor('rxLevel', 'tinyint-nounit-axis', 'Rx level'),
                messageDiscriptors.createDescriptor('gprs', 'gprs-state-axis', 'GPRS state', true)
            ],
            'useRate': false
        };

        var mar3WcdmaStatistic = {
            'isArray': true,
            'isSubDiscriminator': true,
            'name': 'WCDMA statistics',
            'rate': 1,
            'discriminatorField': 'boxId',
            'subDiscriminatorField': 'link',
            'discriminatorNames': [],
            'discriminatorLabel': 'Links CCU',
            'subDiscriminatorLabel': 'box',

            'properties': [
                messageDiscriptors.createDescriptor('wcdmaBand', 'band-axis', 'WCDMA band', true),
                messageDiscriptors.createDescriptor('wcdmaChannel', 'channel-axis', 'WCDMA channel'),
                messageDiscriptors.createDescriptor('gmm', 'gmm-state-axis', 'GMM state', true),
                messageDiscriptors.createDescriptor('plmn1', 'plmn-state-axis', 'PLMN state 1', true),
                messageDiscriptors.createDescriptor('mm', 'mm-state-axis', 'MM state', true),
                messageDiscriptors.createDescriptor('plmn2', 'plmn-state-axis', 'PLMN state 2', true),
                messageDiscriptors.createDescriptor('wcdmal1', 'wcdma-l1-state-axis', 'WCDMA L1 state', true),
                messageDiscriptors.createDescriptor('rrc', 'rrc-state-axis', 'RRC state', true),
                messageDiscriptors.createDescriptor('rxmRssic0', 'tinyint-nounit-axis', 'RxM RSSI C0'),
                messageDiscriptors.createDescriptor('rxdRssic0', 'tinyint-nounit-axis', 'RxD RSSI C0'),
                messageDiscriptors.createDescriptor('rxmRssic1', 'tinyint-nounit-axis', 'RxM RSSI C1'),
                messageDiscriptors.createDescriptor('rxdRssic1', 'tinyint-nounit-axis', 'RxD RSSI C1')
            ],
            'useRate': false
        };


        var mar3LinkSession = {
            'isArray': true,
            'isSubDiscriminator': true,
            'name': 'Link sessions',
            'rate': 1,
            'discriminatorField': 'boxId',
            'subDiscriminatorField': 'link',
            'discriminatorNames': [],
            'discriminators': [],
            'discriminatorLabel': 'Links CCU',
            'subDiscriminatorLabel': 'box',

            'properties': [
                messageDiscriptors.createDescriptor('totalSessions', 'k-number-scale', 'Total sessions'),
                messageDiscriptors.createDescriptor('tcpSessions', 'k-number-scale', 'TCP sessions'),
                messageDiscriptors.createDescriptor('udpSessions', 'k-number-scale', 'UDP sessions'),
                messageDiscriptors.createDescriptor('icmpSessions', 'k-number-scale', 'ICMP sessions'),
            ],
            'useRate': false
        };

        var mar3Congestion = {
            'isArray': true,
            'isSubDiscriminator': true,
            'name': 'Congestion statistics',
            'rate': 1,
            'discriminatorField': 'boxId',
            'subDiscriminatorField': 'link',
            // 'discriminatorNames' will be replaced by the discriptor service
            // it will be a 2 dimensional array [ box id , [ MODEM 1, MODEM 2,MODEM 3] ]
            'discriminatorNames': [],
            'discriminatorLabel': 'Links CCU',
            'subDiscriminatorLabel': 'box',
            'hideVlinks': true,
            'properties': [
                messageDiscriptors.createDescriptor('tput', 'kbitspers', 'Throughput'),
                messageDiscriptors.createDescriptor('tpsAvModem', 'kbitspers', 'Average tps per modem')
            ],
            'useRate': false
        };

        var connections = {
            'isArray': true,
            'name': 'Device count per car',
            'rate': 1,
            'discriminatorField': 'coach',
            'discriminatorNames': [],
            'discriminatorLabel': 'Car',
            'isSubDiscriminator': false,
            'properties': [
                messageDiscriptors.createDescriptor('connectedDevices', 'small-number-scale', 'Devices connected to Wi-Fi')
            ],
            'useRate': false
        };

        var obisDeviceCommon = {
            'isArray': true,
            'discriminatorField': 'deviceType',
            'discriminatorNames': [],
            'discriminatorLabel': 'Device type',
            'isSubDiscriminator': true,
            'subDiscriminatorField': 'deviceId',
            'subDiscriminatorLabel': 'Device',
            'rate': 1,
            'useRate': false
        }

        var obisDeviceTemperature = {
            ...obisDeviceCommon,
            'name': 'Device temperature',
            'properties': [
                messageDiscriptors.createDescriptor('current', 'temperature-celcius', 'Measured temperature'),
                messageDiscriptors.createDescriptor('min', 'temperature-celcius', 'Min. temperature'),
                messageDiscriptors.createDescriptor('max', 'temperature-celcius', 'Max. temperature'),
            ]
            
        };

        var obisDeviceLifeSign = {
            ...obisDeviceCommon,
            'name': 'Device LifeSign',
            'properties': [
                messageDiscriptors.createDescriptor('lifeSign', 'obis-lifesign', 'LifeSign'),
            ]
        };

        var obisDeviceLoopStatus = {
            ...obisDeviceCommon,
            'name': 'Loop status',
            'properties': [
                messageDiscriptors.createDescriptor('indexCategory', 'obis-loopstatus-axis', 'Loop status'),
            ]
        };

        var obisDevicePSUDetails = {
            ...obisDeviceCommon,
            'name': 'PSU details',
            'properties': [
                messageDiscriptors.createDescriptor('primaryPSU', 'boolean-up-down', 'Primary PSU'),
                messageDiscriptors.createDescriptor('inputVoltage', 'boolean-up-down', 'Input voltage'),
                messageDiscriptors.createDescriptor('shutDownInitiated', 'boolean-up-down', 'Shutdown initiated'),
            ]
        };

        var obisDevicePSUDetailsSummary = {
            ...obisDeviceCommon,
            'name': 'PSU details summary',
            'properties': [
                messageDiscriptors.createDescriptor('accuChargePercent', 'zero-to-hundred', 'Accu charge percent'),
                messageDiscriptors.createDescriptor('accuChargingCurrent', 'milli-ampere-axis', 'Accu charging current'),
                messageDiscriptors.createDescriptor('statusFlags', 'boolean-up-down', 'Status flags'),
            ]
        };

        var obisDeviceSWPlatformStatus = {
            ...obisDeviceCommon,
            'name': 'Software platform status',
            'properties': [
                messageDiscriptors.createDescriptor('status', 'tinyint-nounit-axis', 'Status'),
                messageDiscriptors.createDescriptor('indexCode', 'obis-swplatformstatuscode-axis', 'Code'),
            ]
        };

        var obisDeviceAssignedJourney = {
            ...obisDeviceCommon,
            'name': 'Journey ID',
            'properties': [
                messageDiscriptors.createDescriptor('indexJourneyCode', 'obis-journeyid-axis', 'Journey code'),
            ]
        };

        var obisDeviceDegraded = {
            ...obisDeviceCommon,
            'name': 'Global status',
            'properties': [
                messageDiscriptors.createDescriptor('mode', 'tinyint-nounit-axis', 'Degraded mode'),
            ]
        };

        var obisMtsDownloadStatus = {
            ...obisDeviceCommon,
            'name': 'MTS download status',
            'properties': [
                messageDiscriptors.createDescriptor('downloadStatus', 'zero-to-hundred', 'Download status'),
            ]
        };

        var obisDeviceOperationHours = {
            ...obisDeviceCommon,
            'name': 'Operation hours',
            'properties': [
                messageDiscriptors.createDescriptor('pcb', 'tinyint-nounit-axis', 'PCB'),
                messageDiscriptors.createDescriptor('display', 'tinyint-nounit-axis', 'Display 1'),
                messageDiscriptors.createDescriptor('display2', 'tinyint-nounit-axis', 'Display 2'),
            ]
        };

        var obisLine = {
            ...obisDeviceCommon,
            'name': 'Line',
            'properties': [
                messageDiscriptors.createDescriptor('indexName', 'obis-linename-axis', 'Line'),
                messageDiscriptors.createDescriptor('direction', 'tinyint-nounit-axis', 'Direction'),
            ]
        };

        var obisTrainPosition = {
            ...obisDeviceCommon,
            'name': 'Train position',
            'properties': [
                messageDiscriptors.createDescriptor('indexTp', 'obis-tp-axis', 'TP'),
                messageDiscriptors.createDescriptor('indexNextStopCode', 'obis-nextstopcode-axis', 'Next stop code'),
                messageDiscriptors.createDescriptor('indexNextStopName', 'obis-nextstopname-axis', 'Next stop name'),
            ]
        };

        var obisMmdBacklight = {
            ...obisDeviceCommon,
            'name': 'MMD backlight',
            'properties': [
                messageDiscriptors.createDescriptor('screensPerMMD', 'tinyint-nounit-axis', 'Screens per MMD'),
                messageDiscriptors.createDescriptor('error', 'tinyint-nounit-axis', 'Error'),
                messageDiscriptors.createDescriptor('status', 'tinyint-nounit-axis', 'Status'),
                messageDiscriptors.createDescriptor('current', 'tinyint-nounit-axis', 'Current'),
                messageDiscriptors.createDescriptor('min', 'tinyint-nounit-axis', 'Min'),
                messageDiscriptors.createDescriptor('max', 'tinyint-nounit-axis', 'Max'),
                messageDiscriptors.createDescriptor('start', 'tinyint-nounit-axis', 'Start'),
                messageDiscriptors.createDescriptor('dynamicControl', 'tinyint-nounit-axis', 'Dynamic control'),
                messageDiscriptors.createDescriptor('ambient', 'tinyint-nounit-axis', 'Ambient'),
            ]
        };


        var ncCellStatistics = {
            'isArray': true,
            'isSubDiscriminator': true,
            'isSubSubDiscriminator': true,
            'name': 'Cell statistics',
            'rate': 1,
            'discriminatorField': 'boxId',
            'subDiscriminatorField': 'link',
            'subSubdiscriminatorField': 'carrier',
            // 'discriminatorNames' will be replaced by the discriptor service
            // it will be a 2 dimensional array [ box id , [ MODEM 1, MODEM 2,MODEM 3] ]
            'discriminatorNames': [],
            'discriminatorLabel': 'Links CCU',
            'subDiscriminatorLabel': 'box',
            'subSubDiscriminatorLabel': 'Carrier',
            'aggregateVlinks': true,
            'properties': [
                messageDiscriptors.createDescriptor('indexBand', '5g-band-axis', 'Band'),
                messageDiscriptors.createDescriptor('channel', 'channel-axis', 'Channel'),
                messageDiscriptors.createDescriptor('rssi', 'negative-dbm', 'RSSI'),
                messageDiscriptors.createDescriptor('wcdma_rscp', 'db-axis', 'WCDMA RSCP'),
                messageDiscriptors.createDescriptor('lte_rsrq', 'negative-dbm', 'LTE RSRQ'),
                messageDiscriptors.createDescriptor('lte_rsrp', 'negative-dbm', 'LTE RSRP'),
                messageDiscriptors.createDescriptor('lte_sinr', 'db-axis', 'LTE SINR'),
                messageDiscriptors.createDescriptor('lte_bandwidth', 'zero-to-50Mhz', 'LTE bandwidth'),
            ],
            'subSubdiscriminatorValues': [
                'C0',
                'C1',
                'C2',
                'C3',
                'C4',
                'C5',
                'C6'
            ],
            'useRate': false
        };

        fields.gpsData = module.exports.convertDescriptionToStructure('gpsData', gpsData, translateService);
        fields.virtualUser = module.exports.convertDescriptionToStructure('virtualUser', virtualUser, translateService);
        fields.trainUsers = module.exports.convertDescriptionToStructure('trainUsers', trainUsers, translateService);
        fields.allTrainUsers = module.exports.convertDescriptionToStructure('allTrainUsers', allTrainUsers, translateService);
        fields.mar3LinkStatistics = module.exports.convertDescriptionToStructure('mar3LinkStatistics', mar3LinkStatistic, translateService);
        fields.mar3LinkCombined = module.exports.convertDescriptionToStructure('mar3LinkCombined', mar3LinkCombined, translateService);
        fields.mar3LteStatistics = module.exports.convertDescriptionToStructure('mar3LteStatistics', mar3LteStatistic, translateService);
        fields.mar3GsmStatistics = module.exports.convertDescriptionToStructure('mar3GsmStatistics', mar3GsmStatistic, translateService);
        fields.mar3WcdmaStatistics = module.exports.convertDescriptionToStructure('mar3WcdmaStatistics', mar3WcdmaStatistic, translateService);
        fields.mar3LinkSessions = module.exports.convertDescriptionToStructure('mar3LinkSessions', mar3LinkSession, translateService);
        fields.mar3CombinedLinkSessions = module.exports.convertDescriptionToStructure('mar3CombinedLinkSessions', mar3CombinedLinkSession, translateService);
        fields.mar3Congestion = module.exports.convertDescriptionToStructure('mar3Congestion', mar3Congestion, translateService);
        fields.portalConsumptionCombined = module.exports.convertDescriptionToStructure('portalConsumptionCombined', allPortalConsumption, translateService);
        fields.connections = module.exports.convertDescriptionToStructure('connections', connections, translateService);
        fields.capacityTestData = module.exports.convertDescriptionToStructure('capacityTestData', capacityTestData, translateService);
        fields.obisDeviceTemperature = module.exports.convertDescriptionToStructure('obisDeviceTemperature', obisDeviceTemperature, translateService);
        fields.obisDeviceLifeSign = module.exports.convertDescriptionToStructure('obisDeviceLifeSign', obisDeviceLifeSign, translateService);
        fields.obisDeviceLoopStatus = module.exports.convertDescriptionToStructure('obisDeviceLoopStatus', obisDeviceLoopStatus, translateService);
        fields.obisDevicePSUDetails = module.exports.convertDescriptionToStructure('obisDevicePSUDetails', obisDevicePSUDetails, translateService);
        fields.obisDevicePSUDetailsSummary = module.exports.convertDescriptionToStructure('obisDevicePSUDetailsSummary', obisDevicePSUDetailsSummary, translateService);
        fields.obisDeviceSWPlatformStatus = module.exports.convertDescriptionToStructure('obisDeviceSWPlatformStatus', obisDeviceSWPlatformStatus, translateService);
        fields.obisDeviceAssignedJourney = module.exports.convertDescriptionToStructure('obisDeviceAssignedJourney', obisDeviceAssignedJourney, translateService);
        fields.obisDeviceDegraded = module.exports.convertDescriptionToStructure('obisDeviceDegraded', obisDeviceDegraded, translateService);
        fields.obisMtsDownloadStatus = module.exports.convertDescriptionToStructure('obisMtsDownloadStatus', obisMtsDownloadStatus, translateService);
        fields.obisDeviceOperationHours = module.exports.convertDescriptionToStructure('obisDeviceOperationHours', obisDeviceOperationHours, translateService);
        fields.obisLine = module.exports.convertDescriptionToStructure('obisLine', obisLine, translateService);
        fields.obisTrainPosition = module.exports.convertDescriptionToStructure('obisTrainPosition', obisTrainPosition, translateService);
        fields.obisMmdBacklight = module.exports.convertDescriptionToStructure('obisMmdBacklight', obisMmdBacklight, translateService);
        fields.ncCellStatistics = module.exports.convertDescriptionToStructure('ncCellStatistics', ncCellStatistics, translateService);   
        return fields;
    },

    /**
     * Converts a message description to the structure used for displaying data on a chart.
     * @param description
     * @returns {}
     */
    convertDescriptionToStructure: function (id, description, translateService) {
        var structure = {
            id: `I18N_TRIP.MESSAGES_${id}`,
            'isArray': description.isArray,
            'hasDiscriminator': description.isArray,
            'hasSubDiscriminator': util.isDefined(description.isSubDiscriminator) ? description.isSubDiscriminator : false,
            'hasSubSubDiscriminator': util.isDefined(description.isSubSubDiscriminator) ? description.isSubSubDiscriminator : false,
            'name': description.name,
            'rate': description.rate,
            'useRate': description.useRate,
            'description': description,
            'aggregateVlinks': false
        };

        description.properties = description.properties ? description.properties.map(property => {
            return {
                ...property,
                label: translateService.instant(property.label)
            }
        }) : [];

        if (description.isArray) {
            //We have a discriminator
            structure.discriminatorField = description.discriminatorField;
            if (description.isSubDiscriminator) {
                //we have a sub discriminator
                structure.isSubDiscriminator = description.isSubDiscriminator;
                structure.subDiscriminatorField = description.subDiscriminatorField;
                structure.isSubSubDiscriminator = description.isSubSubDiscriminator;
                structure.subSubdiscriminatorField = description.subSubdiscriminatorField;
                structure.discriminators = [];
                structure.aggregateVlinks = description.aggregateVlinks;
                //For each discriminator
                description.discriminatorNames.forEach(function (discriminator) {
                    var definedDiscriminator = discriminator;
                    if (util.isDefined(discriminator[0])) {
                        definedDiscriminator = discriminator[0];
                    }
                    var definedSubDiscriminators = discriminator[1];
                    var subDiscriminators = [];
                    //For each subdiscriminator create an array of objects with name, subid and properties
                    definedSubDiscriminators.forEach(function (subDiscriminator) {
                        var sub = {
                            'name': subDiscriminator,
                            'subid': definedDiscriminator,
                            'properties': angular.copy(description.properties)
                        };
                        subDiscriminators.push(sub);
                    });

                    //Create an entry for the discriminator that includes the array of subdiscriminators
                    //Each discriminator entry will have a name, id, label, subDiscriminatorLabel and subDiscriminators
                    var entry = {
                        'name': definedDiscriminator,
                        'id': Number(definedDiscriminator),
                        'label': description.discriminatorLabel + ' ' + definedDiscriminator,
                        'subDiscriminatorLabel': description.subDiscriminatorLabel + definedDiscriminator,
                        'subDiscriminators': subDiscriminators
                    };

                    if (description.isSubSubDiscriminator) {
                        entry["subSubDiscriminators"] = [...description.subSubdiscriminatorValues]
                        entry["subSubDiscriminatorLabel"] = description.subSubDiscriminatorLabel
                        entry["subSubdiscriminatorField"] = description.subSubdiscriminatorField
                    }
                    structure.discriminators.push(entry);
                });
            } else {
                //no sub discriminator -> make array with objects contains name and properties
                structure.discriminators = [];
                description.discriminatorNames.forEach(function (discriminator) {
                    var entry = {
                        'name': discriminator,
                        'properties': angular.copy(description.properties)
                    };
                    if (util.isDefined(description.discriminatorLabel)) {
                        entry.label = description.discriminatorLabel + ' ' + discriminator;
                    }
                    if (description.isSubSubDiscriminator) {
                        entry["subSubDiscriminators"] = [...description.subSubdiscriminatorValues]
                        entry["subSubDiscriminatorLabel"] = description.subSubDiscriminatorLabel
                        entry["subSubdiscriminatorField"] = description.subSubdiscriminatorField
                    }
                    structure.discriminators.push(entry);
                });
            }
        } else {
            // No discriminator -> flat structure
            structure.properties = description.properties;
        }

        return structure;
    },

    discriptorsTo2DArray: function (discriptors) {
        var twoDArray = [];
        if (util.isDefined(discriptors)) {
            discriptors.forEach(function (discriminator) {
                var subArray = [discriminator.id, discriminator.subdiscriminatorItems];
                twoDArray.push(subArray);
            });
        }
        return twoDArray;
    }
};

